import { useState, useCallback } from "react";
import { ScannerInputValue } from "@/interfaces";
import { AppContextProps } from "./context";

export const useAppContextController = (): AppContextProps => {
  const [searchValue, _setSearchValue] = useState<
    ScannerInputValue | undefined
  >();
  const [isOffsite, _setIsOffsite] = useState(false);

  const setSearchValue = useCallback(
    (_searchValue?: ScannerInputValue) => {
      _setSearchValue(_searchValue);
    },
    [_setSearchValue]
  );

  const setIsOffsite = useCallback(
    (_isOffsite: boolean) => {
      _setIsOffsite(_isOffsite);
    },
    [_setIsOffsite]
  );

  return {
    searchValue,
    setSearchValue,
    isOffsite,
    setIsOffsite,
  };
};
